import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Navigation, Route, Spline, type LucideIcon } from 'lucide-react';
import { DisclaimerGate } from '../features/onboarding/DisclaimerGate.js';
import { SetupGuide } from '../features/onboarding/SetupGuide.js';
import { msg } from '../lib/messages.js';
import './shell.css';

const TABS: Array<{ to: string; label: string; end: boolean; Icon: LucideIcon }> = [
  { to: '/', label: msg.nav.tabNavigate, end: true, Icon: Navigation },
  { to: '/plan', label: msg.nav.tabPlan, end: false, Icon: Route },
  { to: '/turer', label: msg.nav.tabTracks, end: false, Icon: Spline },
];

// Auth is a focused flow — no primary-nav tabs (it has its own back + skip).
const HIDE_TABS = new Set(['/logg-inn', '/registrer', '/glemt-passord']);

export function AppShell(): JSX.Element {
  const location = useLocation();
  // The map screen is full-bleed; the tab bar floats over it.
  const onMap = location.pathname === '/';
  const showTabs = !HIDE_TABS.has(location.pathname);

  return (
    <div className={`shell${onMap ? ' shell--map' : ''}`}>
      <main className="shell__content">
        <Outlet />
      </main>
      {showTabs && (
        <nav className="tabbar" aria-label="Hovednavigasjon">
          {TABS.map(({ to, label, end, Icon }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `tabbar__item${isActive ? ' tabbar__item--active' : ''}`}
            >
              <Icon className="tabbar__icon" />
              <span className="tabbar__label">{label}</span>
            </NavLink>
          ))}
        </nav>
      )}
      <DisclaimerGate />
      <SetupGuide />
    </div>
  );
}
